import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  Validators,
  FormBuilder,
  RequiredValidator,
} from "@angular/forms";
import { getLocaleFirstDayOfWeek } from "@angular/common";
import { CommonService } from "src/app/services/common.service";
import { appConstants } from "src/app/constants/appConstants";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-payment-nro",
  templateUrl: "./payment-nro.component.html",
  styleUrls: ["./payment-nro.component.scss"],
})
export class PaymentNROComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private _commonService: CommonService,
    private _toasterService: ToastrService
  ) {}
  submitted: boolean = false;
  paymentNroForm: FormGroup;
  getForm() {
    this.paymentNroForm = this.fb.group({
      orderId: ["", Validators.required],
      refundType: ["", Validators.required],
      amount: [""],
    });
  }
  refundTypeList: Array<any> = [
    "NRO",
    "RETURN_PICK_UP",
    "PENDING_REFUNDS",
    "PARTIAL_RETURN_REFUND",
  ];
  ngOnInit() {
    this.getForm();
  }
  dropdownChange(event) {
    console.log("event", event);
    if (event == "PARTIAL_RETURN_REFUND") {
      this.paymentNroForm.get("amount").setValidators([Validators.required]);
    } else {
      this.paymentNroForm.get("amount").clearValidators();
    }
  }
  onSubmit() {
    this.submitted = true;
    let url = appConstants.PAYMENT_NRO;
    if (this.paymentNroForm.valid) {
      this._commonService.PostRequest(this.paymentNroForm.value, url).subscribe(
        (res) => {
          this._toasterService.success(
            "status successfully updated",
            "Success",
            {
              timeOut: 1000,
            }
          );
          this.paymentNroForm.reset();
          this.submitted = false;
        },
        (err) => {
          if (err.status == 403) {
            this._toasterService.warning("you don't have permission ");
          } else {
            this._toasterService.warning(err.error.message);
          }
        }
      );
    }
  }
}
